var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        { staticClass: "headline" },
        [
          _c("v-icon", [_vm._v("edit")]),
          _vm._v(" Compensar permiso\n    "),
          _c("v-spacer"),
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.horas_disponibles === null
                  ? ""
                  : "Tiene " + _vm.horas_disponibles + " horas disponibles"
              ) +
              "\n  "
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.adicionarDetalle()
            }
          }
        },
        [
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-container",
                {
                  staticClass: "pa-0",
                  staticStyle: { "min-width": "100%" },
                  attrs: { "grid-list-md": "" }
                },
                [
                  _c(
                    "v-layout",
                    [
                      _c("v-flex", { attrs: { md4: "" } }, [
                        _c("p", [
                          _c("strong", [_vm._v("Total horas a compensar:")]),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.debe_horas_compensacion) +
                              "\n            "
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 96
                    ? _c("p", [
                        _c("strong", [_vm._v(" Respaldo : ")]),
                        _vm._v(_vm._s(_vm.file.name) + "\n        ")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.permiso.id_tipo_permiso == 96
                    ? _c(
                        "v-layout",
                        [
                          _c("v-flex", { attrs: { xs12: "", md4: "" } }, [
                            _c("input", {
                              ref: "file",
                              attrs: {
                                type: "file",
                                accept: "application/pdf",
                                v: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.handleFileUpload()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.denied
                              ? _c("p", { staticClass: "red--text body-1" }, [
                                  _vm._v(
                                    "\n              *Formato no admitido por el sistema\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "text-field-reducido-border",
                            attrs: {
                              outline: "",
                              type: "date",
                              label: "Fecha",
                              rules: _vm.$validate(["required"]),
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.verificaCompensacion()
                              }
                            },
                            model: {
                              value: _vm.form.fecha_desde,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fecha_desde", $$v)
                              },
                              expression: "form.fecha_desde"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "" } },
                        [
                          _c(
                            "v-radio-group",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.verificaCompensacion()
                                }
                              },
                              model: {
                                value: _vm.form.tipo_dia,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "tipo_dia", $$v)
                                },
                                expression: "form.tipo_dia"
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Tarde", value: "2" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md6: "" } },
                        [
                          _c(
                            "v-radio-group",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.verificaCompensacion()
                                }
                              },
                              model: {
                                value: _vm.form.horario,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "horario", $$v)
                                },
                                expression: "form.horario"
                              }
                            },
                            [
                              _c("v-radio", {
                                attrs: { label: "Salida", value: "2" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md6: "" } },
                        [
                          _c("v-select", {
                            staticClass: "text-field-reducido-border",
                            attrs: {
                              outline: "",
                              value: "hora",
                              items: _vm.rango_horarios,
                              type: "hour",
                              "item-value": "hora",
                              "item-text": "hora",
                              label: "Cantidad de horas",
                              autofocus: "",
                              rules: _vm.$validate(["required"]),
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.verificaCompensacion()
                              }
                            },
                            model: {
                              value: _vm.form.horas_compensa,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "horas_compensa", $$v)
                              },
                              expression: "form.horas_compensa"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md6: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "text-field-reducido-border",
                            attrs: {
                              outline: "",
                              type: "time",
                              label: "Hora desde",
                              disabled: ""
                            },
                            model: {
                              value: _vm.hora_desde_calculada,
                              callback: function($$v) {
                                _vm.hora_desde_calculada = $$v
                              },
                              expression: "hora_desde_calculada"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md6: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "text-field-reducido-border",
                            attrs: {
                              outline: "",
                              type: "time",
                              label: "Hora hasta",
                              disabled: ""
                            },
                            model: {
                              value: _vm.hora_hasta_calculada,
                              callback: function($$v) {
                                _vm.hora_hasta_calculada = $$v
                              },
                              expression: "hora_hasta_calculada"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { md6: "" } },
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "success" },
                              on: {
                                click: function($event) {
                                  return _vm.cargarCompensacion()
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("arrow_downward")]),
                              _vm._v("\n              Registrar\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("h3", [_c("strong", [_vm._v("Detalles compensación")])]),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-data-table", {
                        staticClass: "elevation-1 tabla-comprimida-light",
                        attrs: {
                          items: _vm.compensaciones,
                          "hide-actions": "",
                          headers: _vm.headers
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function(props) {
                              return [
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm
                                          .$moment(props.item.fecha)
                                          .format("DD/MM/YYYY")
                                      ) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.hora_desde))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.hora_hasta))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(props.item.total_horas) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-center" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "error",
                                          icon: "",
                                          title: "Eliminar compensacion"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.borrarCompensacionDetalle(
                                              props.item.id
                                            )
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("delete")])],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { staticClass: "pa-2" },
                [
                  _c("v-flex", { attrs: { xs12: "" } }, [
                    _c("h4", [
                      _c("strong", [
                        _vm._v(
                          "Total horas:\n              " +
                            _vm._s(_vm.total_horas_compensacion.format("HH:mm"))
                        )
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "pr-4" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    to: "/permisos/usuario/" + _vm.getPersonaId(),
                    color: "error"
                  }
                },
                [_c("v-icon", [_vm._v("cancel")]), _vm._v("CANCELAR\n      ")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("cancel")]), _vm._v("GUARDAR\n      ")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac5db72c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac5db72c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/components/Compensacion.vue
// module id = null
// module chunks = 